const classExists = document.getElementsByClassName("cta-timeline").length > 0;
;
if (classExists) {

  const cta = document.querySelector(".cta-timeline");
  const targetElement = document.getElementById("timeline");

  cta.addEventListener("click", function (e) {
    e.preventDefault();

    let offset;

    if (window.matchMedia("(min-width: 1280px)").matches) {
      offset = 200;
    } else {
      offset = 172;
    }

    if (targetElement) {
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: targetPosition - offset,
        behavior: "smooth"
      });
    }
  });

}

